import { render } from "./TickOutline.vue?vue&type=template&id=0e4df702"
const script = {}
script.render = render

export default script